import styled from '@emotion/styled'
import * as v from '../../../../../variables/styled'

export const BudgetDetailContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.MuiCardContent-root': {
    paddingTop: '0px',
  }, 
})

export const RequestInformationContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const GeneralInfoContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',

    '.editableSelectInput .default.text': {
      color: 'rgba(191,191,191,.87) !important'
    }
  },
})

export const CardHeaderContent = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: '100%',

  'span.label': {
    fontSize: '1.5rem',
  },

  'div.input': {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '15px',
    alignItems: 'center',

    'span.title': {
      fontSize: '1rem',
    },

    'div.switchContent': {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      margin: '0px 5px',
    },
  },
})

export const HiddenIconButtonContent = styled.div({
  '.MuiSvgIcon-colorDisabled': {
    color: 'transparent',
  }
})
